module.exports = __webpack_public_path__ + "static/img/logo_bg.f22097e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_bg.png
// module id = PhYE
// module chunks = 1